import {formatPrice} from '../common';

(function ($) {
  "use strict";

  window.$ = window.jQuery = $;
  $(function () {
    function myClone(event) {
      var clone = $(event.currentTarget).clone();
      $(clone).attr("id", "myHelper").css("z-index", "999999999999999");
      $('body').append(clone);
      return document.getElementById('myHelper');
    }

    function numberWithSpaces(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(".");
    }

// Инициализация шагов выбора блюд для моб. версии
    function initComboSteps() {
      $('#combo-steps li a').click(function () {
        $('#combo-steps li').removeClass('active');

        var li = $(this).closest('li');
        li.addClass('active');

        var id_block = li.attr('data-item');
        $('.combo-step').hide();

        $('#' + id_block).show('slow');
        return false;
      });
    }

// Инициализация функции для перетаскивание меню в стакан
    function initDragMenu() {
      $('.combo .js-item').draggable({
        create: function () {
          $('.combo .js-item').css({'z-index': '1000000000000'});
        },

        start: function (event, ui) {
          var item = $(event.target).css({'opacity': '0'});

          $('.comboMenu .comboMenu__items .mCSB_container').append(item);

          $('.comboMenu .comboMenu__items .mCSB_container').addClass('scrollContainer');

          $('.comboMenu .comboMenu__items .js-item').each(function (i, el) {
            var index = 100000 - i;
            $(el).css({'z-index': index});
          });
        },

        stop: function (event, ui) {
          $(event.target).css({'opacity': '1', 'cursor': 'pointer'});

          $(event.target).draggable("disable");

          $('.comboMenu .allPrice').css({'opacity': '1'});
          $('.comboMenu__bckgnd-content').css({'opacity': '0'});

          let items = 0;
          $('.comboMenu__items .item').each(function (i, el) {
            items = i + 1;
          });

          if (items > 8) {
            $('.comboMenu__items .item').addClass('itemBasket');
            $('.comboMenu__items').addClass('comboMenu__itemsBasket');
            $('.comboMenu .comboMenu__items .mCSB_container').removeClass('scrollContainer');
          }

          glassItemsTotalSum();
        },

        revert: 'false',
        cursor: 'move',
        containment: 'body',
        snapMode: 'inner',
        snapTolerance: '50',
        snap: '.comboMenu',
        helper: 'myClone'
      });
    }

// Инициализация функции на добавление в стакан при клике на кнопку "Плюс"
    function initAddMenu() {
      $('#galleryCombo .item .icon-add').click(function (event) {

        var item = $(this).closest('.js-item');

        $('.comboMenu .comboMenu__items .mCSB_container').append(item);
        $('.comboMenu .comboMenu__items .mCSB_container').addClass('scrollContainer');

        $('.comboMenu .comboMenu__items .js-item').each(function (i, el) {
          var index = 100000 - i;
          $(el).css({'z-index': index});
        });

        item.draggable("disable");

        $('.comboMenu .allPrice').css({'opacity': '1'});
        $('.comboMenu__bckgnd-content').css({'opacity': '0'});

        let items = -1;
        $('.comboMenu__items .item').each(function (i, el) {
          items = i + 1;
        });

        var summItem = parseInt(item.find('.sum__number').text());

        // summItem = summItem+1;

        item.find('.sum__number').text(summItem);

        item.find('.amount__number').text(summItem);

        item.find('.amount').css('opacity', '1');

        var startPrice = item.find('.item-price-first').text();

        var itemCost = parseInt(item.find('.item-price-first').text().slice(0, -2));


        itemTotalPrice(item, startPrice, summItem);
        glassItemsTotalSum;

        if (items > 8) {
          $('.comboMenu__items .item').addClass('itemBasket');
          $('.comboMenu__items').addClass('comboMenu__itemsBasket');

          $('.comboMenu .comboMenu__items .mCSB_container').removeClass('scrollContainer');
        }


      });
    }

// Инициализация функций при клике на кнопки "Плюс" и "Минус" в стакане
    function changeItemMenu() {
      $('.plusItem .addItemCombo').click(function () {

        var item = $(this).closest('.item');

        item.removeClass('active');

        var summItem = parseInt(item.find('.sum__number').text());

        summItem = summItem + 1;

        item.find('.sum__number').text(summItem);

        item.find('.amount__number').text(summItem);

        item.find('.amount').css('opacity', '1');

        var startPrice = item.find('.item-price-first').text();

        var itemCost = parseInt(item.find('.item-price-first').text().slice(0, -2));

        itemTotalPrice(item, startPrice, summItem);

      });

      $('.plusItem .minusItemCombo').click(function () {
        var item = $(this).closest('.item');
        item.removeClass('active');

        var itemDrag = item.parent();

        var summItem = parseInt(item.find('.sum__number').text());

        var summItemValue = item.find('.sum__number').text();

        var summItemInput = $('#sum-number-input').val(summItemValue);

        switch (summItem) {
          case (2):
            item.find('.amount').css('opacity', '0');

            summItem = summItem - 1;

            item.find('.sum__number').text(summItem);

            item.find('.amount__number').text(summItem);

            var startPrice = item.find('.item-price-first').text();

            var itemCost = parseInt(item.find('.item-price-first').text().slice(0, -2));

            itemTotalPrice(item, startPrice, summItem);

            break;
          case (1):
            $('#galleryCombo .row').append(itemDrag);

            $('#galleryCombo .item').removeClass('active');

            item.find('.amount').css('opacity', '0');

            itemDrag.draggable("enable");

            var items = 0;
            $('.comboMenu__items .item').each(function (i, el) {
              items = i + 1;
            });

            if (items == 0) {
              $('.comboMenu  .allPrice').css({'opacity': '0'});
              $('.comboMenu__bckgnd-content').css({'opacity': '1'});
            }

            summItem = summItem - 1;

            var startPrice = item.find('.item-price-first').text();

            var itemCost = parseInt(item.find('.item-price-first').text().slice(0, -2));

            itemTotalPrice(item, startPrice, summItem);

            break;
          default:
            summItem = summItem - 1;

            item.find('.sum__number').text(summItem);

            item.find('.amount__number').text(summItem);

            var startPrice = item.find('.item-price-first').text();

            var itemCost = parseInt(item.find('.item-price-first').text().slice(0, -2));

            itemTotalPrice(item, startPrice, summItem);
        }

        var items = 0;
        $('.comboMenu__items .item').each(function (i, el) {
          items = i + 1;
        });
        if (items <= 8) {
          $('.comboMenu__items .item').removeClass('itemBasket');
          $('.comboMenu__items').removeClass('comboMenu__itemsBasket');
          $('.comboMenu .comboMenu__items .mCSB_container').addClass('scrollContainer');
        }
      });
    }

    function itemTotalPrice(item, startPrice, quant) {

      var total = startPrice * quant;
      //item.find('.item-price').html(formatPrice(total));
      glassItemsTotalSum();

    }

    function glassItemsTotalSum() {

      var totalSumm = 0;
      $.each($('.comboMenu .item'), function (index, item) {
        var price = parseInt($(item).find('.item-price').text().slice(0, -2).replace(' ', ''));
        var quant = parseInt($(item).find('.sum__number').text());
        totalSumm += price * quant;
      });
      //var formateSum = numberWithSpaces(totalSumm);
      $('.allPrice_sum').html(formatPrice(totalSumm));
    }

    /*
    $(window).on("load", function () {
      $("#galleryCombo").mCustomScrollbar({
        axis: "y",
        theme: "light-3"
      });

      $("#itemsBasketCombo").mCustomScrollbar({
        axis: "y",
        theme: "light-3",
        update: true
      });
    });
    */

    $(function () {
      if ($('.x-combo-detail-scrollfix').length > 0) {
        var height = $('.x-dinner-box').height();
        $('.x-combo-detail-scrollfix').height(height);

        $(window).on('load resize', function() {
          height = $('.x-dinner-box').height();
          $('.x-combo-detail-scrollfix').height(height);
        });
      }

      $('#galleryCombo .item').click(function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
        } else {
          $(this).addClass('active');
        }
      });

      initComboSteps();
      initDragMenu();
      initAddMenu();
      changeItemMenu();

    })
  })
})(jQuery)

